import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const IsNitexStyles = () => {
	const dataList = [
		{ label: 'Yes', value: 'yes' },
		{ label: 'No', value: 'no' }
	];

	const filterData = useSelector((store) => store.filterFieldStore);

	const dispatch = useDispatch();

	const renderDataList = () => {
		return dataList?.map((item) => {
			return (
				<div className="form-group" key={`filter_nitex_design_${item.value}`}>
					<input
						type="checkbox"
						id={`nitex_design_${item.value}`}
						name={`nitex_design_${item.value}`}
						value={item.value}
						onChange={(e) => handleCheckbox(e, item.label)}
						checked={toggleCheckbox(
							filterData,
							'nitexDesign',
							`nitex_design_${item.value}`,
							item.value
						)}
					/>
					<label htmlFor={`nitex_design_${item.value}`}>
						<span>{item.label}</span>
					</label>
				</div>
			);
		});
	};

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'nitexDesign',
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	return (
		<div className="card">
			<div className="card-header" id="headingFive">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#nitexDesign"
						aria-expanded="false"
						aria-controls="nitexDesign"
					>
						Nitex Design
					</button>
				</h5>
			</div>

			<div id="nitexDesign" className="collapse" aria-labelledby="nitexDesign" data-parent="#accordion">
				<div className="card-body">
					<div className="custom-chekbox">{renderDataList()}</div>
				</div>
			</div>
		</div>
	);
};

export default IsNitexStyles;
